module.exports = __webpack_public_path__ + "static/img/21.6ee68c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/gift/21.png
// module id = Pxpb
// module chunks = 2